<ion-header translucent="true" class="custom-header">
    <ion-toolbar>
        <!-- Ícone à esquerda -->
        <ion-icon  slot="start" name="chevron-back-outline"  (click)="dismiss()" ></ion-icon>

        <!-- Título centralizado -->
        <ion-title class="ion-text-center">
            <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
            {{ userData?.firstName }}{{ userData?.age != null ? ', ' + userData?.age : '' }}
            <ion-icon *ngIf="this.userData?.isAvocadoClub" (click)="openModalAvocado()" class="avocado" src="assets/imgs/fyraplus.svg"></ion-icon>
            <ion-icon *ngIf="this.userData?.userValidated" class="avocado" src="assets/imgs/new-check-img.svg"></ion-icon>
        </ion-title>

        <!-- Ícone à direita -->
        <ion-buttons slot="end">
            <ion-button (click)="removeSoul()">
                <ion-icon name="ellipsis-vertical"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="contentStyle">
    <div id="contentDiv">
        <div class="frameDiv">
            <div class="mainDiv">

                <div class="picture-main" height="100%" width="100%">
                    <pinch-zoom *ngIf="pictures.length>0" style="border:none !important;" (dragstart)="$event.preventDefault()" draggable="false">
                        <div class="profile-photo photo-wrapper" #photoRef (click)="onPhotoTap($event)" (dragstart)="$event.preventDefault()" draggable="false">
                            <app-loading-spinner [index]="0" [image]="pictures[galleryIndex]" [fit]="fitContain ? 'contain' : 'cover'" (imageLoadedEvent)="onActivePhotoLoaded()"></app-loading-spinner>
                        </div>
                    </pinch-zoom>
                    <div class="photo-tap-hint"
                        *ngIf="photoHintDirection"
                        [class.photo-tap-hint--next]="photoHintDirection === 'next'"
                        [class.photo-tap-hint--prev]="photoHintDirection === 'prev'"
                        aria-hidden="true">
                        <div class="photo-tap-hint__half"></div>
                        <div class="photo-tap-hint__content">
                            <div class="photo-tap-hint__wash"></div>
                            <div class="photo-tap-hint__peek" *ngIf="photoHintPeekUrl"
                                [style.background-image]="'url(' + photoHintPeekUrl + ')'"></div>
                            <ion-icon class="photo-tap-hint__arrow"
                                [name]="photoHintDirection === 'next' ? 'chevron-forward' : 'chevron-back'"></ion-icon>
                        </div>
                    </div>
                    <!-- Alterna 4:5 cropado ↔ foto inteira; ao mudar a forma a tela reajusta (ícones/espaços). -->
                    <div *ngIf="pictures.length>0 && activePhotoIsLegacy" class="fit-toggle-btn" (click)="toggleFit()">
                        <ion-icon [name]="fitContain ? 'contract-outline' : 'expand-outline'"></ion-icon>
                    </div>
                    <!-- Elogio da foto atualmente exibida. -->
                    <div *ngIf="pictures.length>0 && !howOthersSeeMe" class="recadinho-photo-btn"
                        [class.recadinho-photo-btn--additional]="galleryIndex >= 1" (click)="openRecadinho(galleryIndex)">
                        <img [src]="galleryIndex >= 1 ? 'assets/imgs/icon-elogio-alt.svg' : 'assets/imgs/icon-elogio.svg'" alt="">
                    </div>
                </div>

                <!-- A foto principal é o único visualizador; as miniaturas ficam logo abaixo dela. -->
                <div class="thumb-strip-wrap" *ngIf="pictures.length > 1" [class.has-more]="thumbsHasMore">
                    <div class="thumb-strip" #thumbStrip (scroll)="updateThumbsHasMore()">
                        <div *ngFor="let aPicture of pictures; let i = index" class="thumb-item"
                            [class.active]="i === galleryIndex" (click)="setGalleryPhoto(i)">
                            <div class="thumb-skeleton" *ngIf="!thumbLoaded[i]" aria-hidden="true"></div>
                            <img [src]="aPicture" class="thumb-img" alt="" loading="lazy" decoding="async"
                                (load)="onThumbLoad(i)" (error)="onThumbLoad(i)"
                                (dragstart)="$event.preventDefault()" draggable="false">
                        </div>
                    </div>
                    <div class="thumb-more" *ngIf="thumbsHasMore" aria-hidden="true">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
                <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                <div class="aboutText selectext" *ngIf="(this.userData?.about!=null && this.userData?.about!=='')">
                    <span>{{'aboutMe' | translate}}</span>
                    <span [style.whiteSpace]="'pre-wrap'">{{this.userData?.about}}</span>
                </div>

                <div class="profileData profileDataTablet" *ngIf="userData?.socialCauses && userData?.socialCauses.length > 0">
                    <span>{{'socialCauses' | translate}}</span>

                    <ng-container *ngIf="userData?.socialCauses && userData?.socialCauses.length > 0">
                        <ion-chip class="dataTag" *ngFor="let cause of userData?.socialCauses">
                            <ion-label>{{getSocialCauseDisplayText(cause)}}</ion-label>
                        </ion-chip>
                    </ng-container>
                </div>

                <div class="profileData profileDataTablet">
                    <span>{{'moreDetails' | translate}}</span>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.city!=null&&userData?.city.trim()!==''">
                        <ion-icon class="no-stroke" src="assets/imgs/icons/icon-location-small.svg"></ion-icon>
                        <ion-label>{{userData?.city}}</ion-label>
                    </ion-chip>
                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.genderdescription!=null && userData?.genderdescription.trim()!==''">
                        <ion-icon class="no-stroke" src="/assets/imgs/custom-svg/padronized-sizes/gender.svg"></ion-icon>
                        <ion-label>{{userData?.genderdescription}}</ion-label>
                    </ion-chip>

                    <ion-chip class="dataTag"
                        *ngIf="userData?.lookingFor?.length === 1 && userData.lookingFor.includes('friendship')">
                        <ion-icon src="assets/imgs/icons/amigos-vazado.svg"></ion-icon>
                        <ion-label>{{'friendshipOnly' | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.activism!=null && userData?.activism.trim()!==''">
                        <ion-icon src="assets/imgs/custom-svg/padronized-sizes/activism.svg"></ion-icon>
                        <ion-label>{{userData?.activism | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.work!=null&&userData?.work.trim()!==''">
                        <ion-icon src="assets/imgs/icons/work-white.svg"></ion-icon>
                        <ion-label>{{userData?.work | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.education!=null && userData?.education.trim()!==''">
                        <ion-icon src="assets/imgs/icons/education-white.svg"></ion-icon>
                        <ion-label>{{userData?.education | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.height!=null">
                        <ion-icon src="assets/imgs/icons/height-white.svg"></ion-icon>
                        <ion-label>{{setHeight()}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.exercise!=null && userData?.exercise.trim()!==''">
                        <ion-icon src="assets/imgs/icons/exercise-white.svg"></ion-icon>
                        <ion-label>{{userData?.exercise | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.lookingFor!=null&&userData?.lookingFor.length>0">
                        <ion-icon src="assets/imgs/icons/search-white.svg"></ion-icon>
                        <ion-label>{{lookingForOptions()}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.children!=null && userData?.children.trim()!==''">
                        <ion-icon src="assets/imgs/icons/kids-white.svg"></ion-icon>
                        <ion-label>{{userData?.children | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.astrologySign!=null&&userData?.astrologySign.trim()!==''">
                        <ion-icon src="assets/imgs/icons/sign-white.svg"></ion-icon>
                        <ion-label>{{userData?.astrologySign | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.religion!=null&&userData?.religion.trim()!==''">
                        <ion-icon src="assets/imgs/icons/religion-white.svg"></ion-icon>
                        <ion-label>{{userData?.religion | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.politics!=null&&userData?.politics.trim()!==''">
                        <ion-icon src="assets/imgs/icons/politics-white.svg"></ion-icon>
                        <ion-label>{{userData?.politics | translate}}</ion-label>
                    </ion-chip>

                    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                    <ion-chip class="dataTag" *ngIf="userData?.pets!=null&&userData?.pets.trim()!==''">
                        <ion-icon src="assets/imgs/icons/animals-white.svg"></ion-icon>
                        <ion-label>{{userData?.pets}}</ion-label>
                    </ion-chip>
                </div>
                <ion-row class="last-seen-row">
                    <span class="distance-units">{{'lastSeen' | translate}}
                        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
                        {{userData?.distance!=null?userData?.distance:'0 miles'}} {{'fromYou' | translate}}</span>
                </ion-row>
            </div>
        </div>

    </div>

</ion-content>

<ion-footer *ngIf="!howOthersSeeMe">
    <ion-grid>
        <ion-row>
            <ion-col size="12" *ngIf="this.userData?.match">
                <ion-button shape="round" expand="full" color="primary" (click)="chat()">
                    &nbsp; <ion-icon class="buttonIcon" name="chatbubbles"></ion-icon>
                    {{'chat' | translate}}</ion-button>
            </ion-col>
        </ion-row>
        <app-slider-control 
            #sliderRef
            *ngIf="!this.userData?.match && sliderReady"
            [initialState]="this.userData.sliderState"
            [enableHide]="true"
            (stateChange)="onSliderMudou($event)"
            (hideTriggered)="hide()"
            (dragEnd)="onDragEnd($event)"
            (dragProgress)="onDragProgress($event)">
        </app-slider-control>
    </ion-grid>

</ion-footer>
